import { Button } from "antd";
import FullPageLayout from "../../../../templates/FullPageLayout";
import { useState } from "react";
import { NeedHelp } from "../../../../atoms/CustomIcons";
import AddServiceStep1 from "./AddServiceStep1";
import AddServiceStep2 from "./AddServiceStep2";

export default function AddService() {
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const serviceLineId = pathSegments[pathSegments.length - 2];
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState(null);
  const [current, setCurrent] = useState(0);

  const steps = [
    {
      title: "Select Center Person",
      content: (
        <AddServiceStep1
          setCurrent={setCurrent}
          setType={setType}
          type={type}
          companyId={companyId}
          serviceLineId={serviceLineId}
        />
      ),
    },
    {
      title: "General details",
      content: (
        <AddServiceStep2
          setCurrent={setCurrent}
          setLoading={setLoading}
          companyId={companyId}
          serviceLineId={serviceLineId}
          type={type}
        />
      ),
    },
  ];

  return (
    <FullPageLayout loading={loading}>
      <Button className="btn-sm fixedTopBtn">
        <NeedHelp /> Need help?
      </Button>
      <div className="ServicesSteps"> {steps[current].content} </div>
    </FullPageLayout>
  );
}
